import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, TextInput, Dimensions, ScrollView } from 'react-native';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/pages/homeStyles';
import { API_URL } from '../config';
import { showError, showSuccess, showConfirm } from '../utils/sweetAlert';
import { useMediaQuery } from 'react-responsive';
import AppLayout from '../components/layout/AppLayout';

export default function Home() {
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const isMobile = Dimensions.get('window').width < 768;
  const isDesktop = useMediaQuery({ minWidth: 768 });

  useEffect(() => {
    const verified = sessionStorage.getItem('isOTPVerified');
    if (verified === 'true') {
      setIsVerified(true);
      // 모바일에서만 바로 projectstatus로 이동
      if (!isDesktop) {
        navigate('/projectstatus');
      }
    }
  }, [navigate, isDesktop]);

  const verifyOTP = async () => {
    try {
      const response = await fetch(`${API_URL}/api/otp/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: otpCode }),
      });
  
      const data = await response.json();
      if (data.data.ok && data.data.success) {
        sessionStorage.setItem('isOTPVerified', 'true');
        setIsVerified(true);
        // 모바일은 projectstatus로, PC는 메인 대시보드 표시
        if (!isDesktop) {
          navigate('/projectstatus');
        }
      } else {
        showError('OTP 코드가 올바르지 않습니다.');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      showError('OTP 인증 중 오류가 발생했습니다.');
    }
  };

  // PC에서 인증이 완료된 경우에만 안내 화면 렌더링
  if (isDesktop && isVerified) {
    return (
      <AppLayout title="PMS - Project Management System">
        <ScrollView style={{ flex: 1, backgroundColor: '#f0f2f5' }}>
          <View style={{ padding: 24 }}>
            {/* 환영 섹션 */}
            <View style={{
              backgroundColor: 'white',
              padding: 32,
              borderRadius: 8,
              marginBottom: 24,
              alignItems: 'center',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 3,
            }}>
              <Text style={{
                fontSize: 28,
                fontWeight: 'bold',
                color: '#1890ff',
                marginBottom: 16,
              }}>
                PMS - Project Management System
              </Text>
              <Text style={{
                fontSize: 16,
                color: '#666',
                textAlign: 'center',
                marginBottom: 8,
              }}>
                프로젝트 관리 시스템에 오신 것을 환영합니다.
              </Text>
              <Text style={{
                fontSize: 14,
                color: '#999',
                textAlign: 'center',
              }}>
                좌측 메뉴에서 원하는 기능을 선택하거나 아래 바로가기를 이용하세요.
              </Text>
            </View>

            {/* 빠른 시작 섹션 */}
            <Text style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginBottom: 24,
              color: '#333',
            }}>
              빠른 시작
            </Text>
            
            <View style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              marginHorizontal: -8,
            }}>
              {/* 프로젝트 생성 카드 */}
              <View style={{ width: '25%', padding: 8 }}>
                <TouchableOpacity
                  style={{
                    backgroundColor: 'white',
                    height: 200,
                    borderRadius: 8,
                    borderWidth: 2,
                    borderColor: '#4CAF50',
                    padding: 24,
                    justifyContent: 'space-between',
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  onPress={() => navigate('/create-project')}
                >
                  <View style={{ alignItems: 'center' }}>
                    <Text style={{ fontSize: 24, marginBottom: 16 }}>➕</Text>
                    <Text style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#4CAF50',
                      marginBottom: 8,
                      textAlign: 'center',
                    }}>
                      프로젝트 생성
                    </Text>
                    <Text style={{
                      fontSize: 12,
                      color: '#666',
                      textAlign: 'center',
                    }}>
                      새로운 프로젝트를 생성하고 관리합니다.
                    </Text>
                  </View>
                  <View style={{
                    backgroundColor: '#4CAF50',
                    paddingVertical: 8,
                    borderRadius: 4,
                    alignItems: 'center',
                  }}>
                    <Text style={{ color: 'white', fontWeight: 'bold' }}>시작하기</Text>
                  </View>
                </TouchableOpacity>
              </View>

              {/* 프로젝트 상태 카드 */}
              <View style={{ width: '25%', padding: 8 }}>
                <TouchableOpacity
                  style={{
                    backgroundColor: 'white',
                    height: 200,
                    borderRadius: 8,
                    borderWidth: 2,
                    borderColor: '#1890ff',
                    padding: 24,
                    justifyContent: 'space-between',
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  onPress={() => navigate('/projectstatus')}
                >
                  <View style={{ alignItems: 'center' }}>
                    <Text style={{ fontSize: 24, marginBottom: 16 }}>📊</Text>
                    <Text style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#1890ff',
                      marginBottom: 8,
                      textAlign: 'center',
                    }}>
                      프로젝트 상태
                    </Text>
                    <Text style={{
                      fontSize: 12,
                      color: '#666',
                      textAlign: 'center',
                    }}>
                      프로젝트 진행 상황을 실시간으로 확인합니다.
                    </Text>
                  </View>
                  <View style={{
                    backgroundColor: '#1890ff',
                    paddingVertical: 8,
                    borderRadius: 4,
                    alignItems: 'center',
                  }}>
                    <Text style={{ color: 'white', fontWeight: 'bold' }}>시작하기</Text>
                  </View>
                </TouchableOpacity>
              </View>

              {/* 크론잡 대시보드 카드 */}
              <View style={{ width: '25%', padding: 8 }}>
                <TouchableOpacity
                  style={{
                    backgroundColor: 'white',
                    height: 200,
                    borderRadius: 8,
                    borderWidth: 2,
                    borderColor: '#FF9800',
                    padding: 24,
                    justifyContent: 'space-between',
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  onPress={() => navigate('/cron-dashboard')}
                >
                  <View style={{ alignItems: 'center' }}>
                    <Text style={{ fontSize: 24, marginBottom: 16 }}>⚙️</Text>
                    <Text style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#FF9800',
                      marginBottom: 8,
                      textAlign: 'center',
                    }}>
                      크론잡 관리
                    </Text>
                    <Text style={{
                      fontSize: 12,
                      color: '#666',
                      textAlign: 'center',
                    }}>
                      Redmine 동기화 작업을 모니터링하고 관리합니다.
                    </Text>
                  </View>
                  <View style={{
                    backgroundColor: '#FF9800',
                    paddingVertical: 8,
                    borderRadius: 4,
                    alignItems: 'center',
                  }}>
                    <Text style={{ color: 'white', fontWeight: 'bold' }}>시작하기</Text>
                  </View>
                </TouchableOpacity>
              </View>

              {/* SSL 모니터링 카드 */}
              <View style={{ width: '25%', padding: 8 }}>
                <TouchableOpacity
                  style={{
                    backgroundColor: 'white',
                    height: 200,
                    borderRadius: 8,
                    borderWidth: 2,
                    borderColor: '#9C27B0',
                    padding: 24,
                    justifyContent: 'space-between',
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3,
                  }}
                  onPress={() => navigate('/ssl-monitoring')}
                >
                  <View style={{ alignItems: 'center' }}>
                    <Text style={{ fontSize: 24, marginBottom: 16 }}>🔒</Text>
                    <Text style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#9C27B0',
                      marginBottom: 8,
                      textAlign: 'center',
                    }}>
                      SSL 모니터링
                    </Text>
                    <Text style={{
                      fontSize: 12,
                      color: '#666',
                      textAlign: 'center',
                    }}>
                      SSL 인증서 만료일을 실시간으로 모니터링합니다.
                    </Text>
                  </View>
                  <View style={{
                    backgroundColor: '#9C27B0',
                    paddingVertical: 8,
                    borderRadius: 4,
                    alignItems: 'center',
                  }}>
                    <Text style={{ color: 'white', fontWeight: 'bold' }}>시작하기</Text>
                  </View>
                </TouchableOpacity>
              </View>
            </View>

            {/* 시스템 정보 섹션 */}
            <View style={{
              flexDirection: 'row',
              marginTop: 32,
              marginHorizontal: -8,
            }}>
              <View style={{ width: '50%', padding: 8 }}>
                <View style={{
                  backgroundColor: 'white',
                  padding: 20,
                  borderRadius: 8,
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.1,
                  shadowRadius: 4,
                  elevation: 3,
                }}>
                  <Text style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: 12,
                    color: '#333',
                  }}>
                    주요 기능
                  </Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• 새 프로젝트 생성 및 설정</Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• 프로젝트 진행 상황 모니터링</Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• 실시간 진척도 확인</Text>
                  <Text style={{ color: '#666' }}>• 프로젝트 뉴스 피드</Text>
                </View>
              </View>
              
              <View style={{ width: '50%', padding: 8 }}>
                <View style={{
                  backgroundColor: 'white',
                  padding: 20,
                  borderRadius: 8,
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.1,
                  shadowRadius: 4,
                  elevation: 3,
                }}>
                  <Text style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: 12,
                    color: '#333',
                  }}>
                    시스템 정보
                  </Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• React Native Web 기반</Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• 반응형 디자인</Text>
                  <Text style={{ color: '#666', marginBottom: 4 }}>• RESTful API 연동</Text>
                  <Text style={{ color: '#666' }}>• 실시간 데이터 동기화</Text>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      </AppLayout>
    );
  }

  // 모바일과 PC에서 인증되지 않은 경우 OTP 화면 표시
  return (
    <View style={[
      styles.container, 
      isDesktop && { 
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: '#f0f2f5',
        minHeight: '100vh' as any,
        width: '100vw' as any,
      }
    ]}>
      {isDesktop ? (
        // PC 버전 - title과 OTP 컨테이너를 하나로 묶어서 중앙 정렬
        <View style={{
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 400, // 전체를 위로 올리기 위해 margin 추가
        }}>
          <TouchableOpacity onPress={() => navigate('/registOTP')}>
            <Text style={[styles.title, { fontSize: 32, marginBottom: 40, textAlign: 'center' }]}>Dain Leaders PMS</Text>
          </TouchableOpacity>
          <View style={{
            backgroundColor: 'white',
            padding: 40,
            borderRadius: 8,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
            width: 400,
          }}>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              marginBottom: 20,
              textAlign: 'center',
              color: '#333',
            }}>
              OTP 인증
            </Text>
            <TextInput
              style={{
                width: '100%',
                height: 50,
                borderWidth: 1,
                borderColor: '#d9d9d9',
                borderRadius: 4,
                paddingHorizontal: 12,
                fontSize: 16,
                marginBottom: 20,
              }}
              placeholder="Google OTP 코드를 입력하세요"
              value={otpCode}
              onChangeText={setOtpCode}
              keyboardType="number-pad"
              maxLength={6}
              onSubmitEditing={verifyOTP}
            />
            <TouchableOpacity
              style={{
                width: '100%',
                height: 50,
                backgroundColor: '#1890ff',
                borderRadius: 4,
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onPress={verifyOTP}
            >
              <Text style={{
                color: 'white',
                fontSize: 16,
                fontWeight: 'bold',
              }}>인증하기</Text>
            </TouchableOpacity>
          </View>
        </View>
      ) : (
        // 모바일 버전 - 기존 레이아웃 유지
        <>
          <TouchableOpacity onPress={() => navigate('/registOTP')}>
            <Text style={styles.title}>Dain Leaders PMS</Text>
          </TouchableOpacity>
          <View style={isMobile ? styles.mobileOtpContainer : styles.webOtpContainer}>
            <TextInput
              style={isMobile ? styles.mobileOtpInput : styles.otpInput}
              placeholder="Google OTP 코드를 입력하세요"
              value={otpCode}
              onChangeText={setOtpCode}
              keyboardType="number-pad"
              maxLength={6}
              onSubmitEditing={verifyOTP}
            />
            <TouchableOpacity
              style={isMobile ? styles.mobileVerifyButton : styles.verifyButton}
              onPress={verifyOTP}
            >
              <Text style={isMobile ? styles.mobileButtonText : styles.buttonText}>인증하기</Text>
            </TouchableOpacity>
          </View>
        </>
      )}
    </View>
  );
}